import { isEmpty, isString } from "lodash";
import EncryptionUtils from "@helpers/EncryptionUtils";

export const applyRequestEncryption = (config) => {
  if (Array.isArray(config.keys) && config.keys?.length > 0) {
    config.headers = {
      ...config.headers,
      "Has-Encrypted-Data": true,
      "Encrypted-Props": config.keys.join(",")
    };

    for (let key of config.keys) {
      if (isString(key) && !isEmpty(key) && config?.data?.hasOwnProperty(key)) {
        config.data[key] = EncryptionUtils.encrypt(config.data[key]);
      }
    }
  }
  return config;
};

export const decryptResponseProps = (response) => {
  if (response && response.data && response.data?.data && response.headers) {
    const hasEncryptedData = response.headers["has-encrypted-data"] == 1;
    const hasEncryptedProps = "encrypted-props" in response.headers;

    if (hasEncryptedData && hasEncryptedProps) {
      const propsToDecrypt = response.headers["encrypted-props"]?.split(",") || [];

      for (let key of propsToDecrypt) {
        const k = key?.trim();
        if (isString(k) && !isEmpty(k) && response?.data?.data.hasOwnProperty(k)) {
          response.data.data[k] = EncryptionUtils.decrypt(response.data.data[k]);
        }
      }
    }
  }
  return response;
};
